import { useState } from "react";
import { grantsApi } from "../lib/api.js";

const empty = {
  organization: "",
  projectTitle: "",
  requestedBudget: "",
  abstractSummary: "",
  documentUrl: "",
  fundingCycle: "",
};

export default function CreateGrantModal({ onClose, onCreated }) {
  const [form, setForm] = useState(empty);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const payload = {
        ...form,
        requestedBudget: Number(form.requestedBudget),
      };
      await grantsApi.create(payload);
      onCreated();
    } catch (err) {
      setError(err.message || "Failed to create grant");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-30 flex items-center justify-center bg-ink-900/40 p-4" role="dialog" aria-modal="true" aria-label="Create grant">
      <div className="card w-full max-w-lg p-6">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-ink-900">New Grant Application</h2>
          <button onClick={onClose} className="text-ink-400 hover:text-ink-700" aria-label="Close">✕</button>
        </div>
        {error && <div role="alert" className="mb-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-3" noValidate>
          <div>
            <label className="label" htmlFor="org">Applicant Organization</label>
            <input id="org" className="input" value={form.organization} onChange={update("organization")} required />
          </div>
          <div>
            <label className="label" htmlFor="title">Project Title</label>
            <input id="title" className="input" value={form.projectTitle} onChange={update("projectTitle")} required />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label" htmlFor="budget">Requested Budget (USD)</label>
              <input id="budget" type="number" min="0" step="100" className="input" value={form.requestedBudget} onChange={update("requestedBudget")} required />
            </div>
            <div>
              <label className="label" htmlFor="cycle">Funding Cycle</label>
              <input id="cycle" className="input" value={form.fundingCycle} onChange={update("fundingCycle")} placeholder="FY2026-Q1" />
            </div>
          </div>
          <div>
            <label className="label" htmlFor="doc">External Document URL (PDF)</label>
            <input id="doc" type="url" className="input" value={form.documentUrl} onChange={update("documentUrl")} required />
          </div>
          <div>
            <label className="label" htmlFor="abstract">Abstract Summary</label>
            <textarea id="abstract" rows={3} className="input" value={form.abstractSummary} onChange={update("abstractSummary")} required />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={submitting}>{submitting ? "Saving…" : "Create Grant"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
